import React from 'react';
import TooltipMui, { TooltipProps } from '@mui/material/Tooltip';

const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>((props, ref) => (
  <TooltipMui ref={ref} {...props} arrow />
));

export default Tooltip;
